var _circle, _rect, _path, _rect2, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg1460(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.1992,
    cy: 9.5,
    r: 9,
    stroke: "#AEAEAE"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.69922,
    y: 7,
    width: 2,
    height: 5,
    fill: "#AEAEAE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.19922 15L8.19922 13L12.1992 13L12.1992 15L8.19922 15Z",
    fill: "#AEAEAE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.6992,
    y: 7,
    width: 2,
    height: 5,
    fill: "#AEAEAE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6992 4.5C11.6992 5.32843 11.0276 6 10.1992 6C9.37079 6 8.69922 5.32843 8.69922 4.5C8.69922 3.67157 9.37079 3 10.1992 3C11.0276 3 11.6992 3.67157 11.6992 4.5Z",
    fill: "#AEAEAE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1460);
export default __webpack_public_path__ + "static/media/14-60.64e9458b8be6d14ef6453a1be8efc583.svg";
export { ForwardRef as ReactComponent };